module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_photo_capturing-f05d943663ab886ea0a533988a7cc45c.svg";